import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const updateTopping = async (placeId, toppingId, update) => {
  if (!placeId || !toppingId || !update) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/toppings/${toppingId}/update`,
    data: update,
  });
};